import React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import './admin-filters.scss';

const inputSx = {
    minWidth: { xs: '100%', sm: 280, md: 320 },
    flex: 1,
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': { borderColor: '#434851' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#434851' },
};

export default function AdminFilters({ search, onSearchChange, placeholder, children }) {
    return (
        <Box className="admin-filters">
            <TextField
                size="small"
                placeholder={placeholder || 'Pesquise por nome ou e-mail'}
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ color: '#434851' }} />
                        </InputAdornment>
                    ),
                }}
                sx={inputSx}
            />
            {children}
        </Box>
    );
}
